export const subCategoriesMap = {
  assets: [
    "BankAccounts", "Deposits", "Real-Estate", "Gold-Silver", "Stocks",
    "MutualFunds", "Cash", "Crypto", "Other-Assets"
  ],

  liabilities: [
    "VehicleLoan", "HomeLoan", "EducationLoan", "PersonalLoan",
    "CreditCardBills", "Other-Liabilities"
  ],

  maintenance: [
    "HealthInsurance", "LifeInsurance", "HomeInsurance", "CardInsurance"
  ],

  infoDocs: ["Notes", "Documents"],

  // Category: /category/trustedContacts
  trustedContacts: [
    "trustedContacts"
  ],

  // Category: /category/inactivitySettings
  inactivitySettings: [
    "inactivitySettings"
  ]
};
